// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICustomPageable } from './ICustomPageable';
import {
    ICustomPageableFromJSON,
    ICustomPageableFromJSONTyped,
    ICustomPageableToJSON,
    ICustomPageableToJSONTyped,
} from './ICustomPageable';
import type { IClaimsResponseAggregatorDto } from './IClaimsResponseAggregatorDto';
import {
    IClaimsResponseAggregatorDtoFromJSON,
    IClaimsResponseAggregatorDtoFromJSONTyped,
    IClaimsResponseAggregatorDtoToJSON,
    IClaimsResponseAggregatorDtoToJSONTyped,
} from './IClaimsResponseAggregatorDto';

/**
 * 
 * @export
 * @interface IClaimsResponseAggregatorDtoPage
 */
export interface IClaimsResponseAggregatorDtoPage {
    /**
     * 
     * @type {number}
     * @memberof IClaimsResponseAggregatorDtoPage
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimsResponseAggregatorDtoPage
     */
    size?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimsResponseAggregatorDtoPage
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimsResponseAggregatorDtoPage
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimsResponseAggregatorDtoPage
     */
    empty?: boolean;
    /**
     * 
     * @type {Array<IClaimsResponseAggregatorDto>}
     * @memberof IClaimsResponseAggregatorDtoPage
     */
    content?: Array<IClaimsResponseAggregatorDto>;
    /**
     * 
     * @type {ICustomPageable}
     * @memberof IClaimsResponseAggregatorDtoPage
     */
    pageable?: ICustomPageable;
    /**
     * 
     * @type {number}
     * @memberof IClaimsResponseAggregatorDtoPage
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimsResponseAggregatorDtoPage
     */
    number_of_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimsResponseAggregatorDtoPage
     */
    total_elements?: number;
}

/**
 * Check if a given object implements the IClaimsResponseAggregatorDtoPage interface.
 */
export function instanceOfIClaimsResponseAggregatorDtoPage(value: object): value is IClaimsResponseAggregatorDtoPage {
    return true;
}

export function IClaimsResponseAggregatorDtoPageFromJSON(json: any): IClaimsResponseAggregatorDtoPage {
    return IClaimsResponseAggregatorDtoPageFromJSONTyped(json, false);
}

export function IClaimsResponseAggregatorDtoPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimsResponseAggregatorDtoPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'] == null ? undefined : json['number'],
        'size': json['size'] == null ? undefined : json['size'],
        'last': json['last'] == null ? undefined : json['last'],
        'first': json['first'] == null ? undefined : json['first'],
        'empty': json['empty'] == null ? undefined : json['empty'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IClaimsResponseAggregatorDtoFromJSON)),
        'pageable': json['pageable'] == null ? undefined : ICustomPageableFromJSON(json['pageable']),
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
    };
}

export function IClaimsResponseAggregatorDtoPageToJSON(json: any): IClaimsResponseAggregatorDtoPage {
    return IClaimsResponseAggregatorDtoPageToJSONTyped(json, false);
}

export function IClaimsResponseAggregatorDtoPageToJSONTyped(value?: IClaimsResponseAggregatorDtoPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'last': value['last'],
        'first': value['first'],
        'empty': value['empty'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IClaimsResponseAggregatorDtoToJSON)),
        'pageable': ICustomPageableToJSON(value['pageable']),
        'totalPages': value['total_pages'],
        'numberOfElements': value['number_of_elements'],
        'totalElements': value['total_elements'],
    };
}

